export default {
    state: {
        model: {
            orderNumber: '',
            name: '',
            orders: []
        }
    }
};
